module.exports = __webpack_public_path__ + "img/img_passcard_funder.8caf8b2a.png";